export default __webpack_public_path__ + "static/media/sccInfo.54fe0f72.svg";